import React, { useEffect, useState, } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
import { selectValueRules } from '../../utils/selectValueRules';
const Select = (props) => {
    var _a;
    const [value, setValue] = useState();
    const [required, setRequired] = useState(false);
    const [valid, setValid] = useState(false);
    useEffect(() => {
        const newValue = selectValueRules(value, props.value, props.optionsLabel, props.values);
        if (newValue !== value) {
            setValue(newValue);
            setValid(!!newValue);
        }
    }, [props.optionsLabel, props.value, props.values]);
    useEffect(() => {
        var _a;
        if (valid && props.isValid) {
            props.isValid({
                key: props.id,
                valid: true,
            });
        }
        (_a = props.onValidChange) === null || _a === void 0 ? void 0 : _a.call(props, props.id, valid || !props.required);
    }, [valid, props.required]);
    const handleInvalid = (event) => {
        event.preventDefault();
        setRequired(true);
    };
    const handleChange = (event) => {
        var _a;
        if (props.forceLabelAfterSelected) {
            setValue(event.target.value);
            setTimeout(() => {
                setValue('');
            }, 500);
        }
        else {
            setValue(event.target.value);
        }
        if (required) {
            setRequired(false);
        }
        else {
            setValid(true);
        }
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event.target.value);
    };
    return (React.createElement("div", { className: classNames(midas.formGroup, required && midas.hasWarning, valid && midas.hasSuccess), "data-cy": props.dataCy, "data-testid": props.dataTestId },
        props.label && (React.createElement("label", { className: midas.formLabel, htmlFor: props.id },
            props.label,
            " ",
            !!props.required && React.createElement("span", null, "*"))),
        React.createElement("select", { ...{
                className: midas.formSelect,
                id: props.id,
                name: props.id,
                required: !!props.required,
                disabled: props.disabled,
                value,
                onChange: (e) => handleChange(e),
                onInvalid: (e) => !props.disabled && handleInvalid(e),
            } },
            props.optionsLabel && (React.createElement("option", { disabled: true, value: "" }, props.optionsLabel)), (_a = props.values) === null || _a === void 0 ? void 0 :
            _a.map((val) => (React.createElement("option", { key: val.key, value: val.value }, val.valueLabel)))),
        required && typeof props.required === 'string' && (React.createElement("span", { className: midas.formInputHint }, props.required)),
        props.children));
};
export default Select;
